import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui: {
    loading: false,
  },
  meal: {},
};

export const mealReducerSlice = createSlice({
  name: 'meal',
  initialState,
  reducers: {
    get_meal: (state) => {
      state.ui.loading = true;
    },
    get_meal_error: (state) => {
      state.ui.loading = false;
    },
    get_meal_success: (state, { payload }) => {
      state.ui.loading = false;
      state.meal = payload;
    },
    update_base_ingredient: (state, { payload }) => {
      const base_ingredients = state.meal.base_ingredients.map((ingredient) => {
        if (ingredient._id === payload._id) {
          let temp = { ...ingredient, selected: !ingredient.selected };
          return temp;
        }
        return ingredient;
      });
      state.meal = {
        ...state.meal,
        base_ingredients,
      };
      return state;
    },
    update_other_ingredient: (state, { payload }) => {
      const ingredient = state.meal.other_ingredients[payload.idx];
      ingredient['selected'] = payload.selected;
      state.meal.other_ingredients[payload.idx] = ingredient;
    },
    add_recipe_product_success: (state) => {
      state.ui.loading = false;
    },
    add_recipe_product_error: (state) => {
      state.ui.loading = false;
    },
    add_recipe_product: (state) => {
      state.ui.loading = true;
    },
  },
});

export const {
  get_meal,
  get_meal_error,
  get_meal_success,
  update_base_ingredient,
  update_other_ingredient,
  add_recipe_product_success,
  add_recipe_product_error,
  add_recipe_product,
} = mealReducerSlice.actions;

export default mealReducerSlice.reducer;
